import { useQuery } from '@tanstack/react-query';
import { Calculator, Sparkles, Check } from 'lucide-react';
import { api } from '../../lib/api';

export function TaxAdjustmentPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['tax-adjustments'],
    queryFn: () => api.get<{ data: any[] }>('/api/tax/adjustments'),
  });

  return (
    <div className="space-y-6 animate-fadeIn">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold" style={{ color: 'var(--text-primary)' }}>法人税申告調整</h1>
        <button className="flex items-center gap-2 px-4 py-2 rounded-lg text-white font-medium" style={{ backgroundColor: 'var(--accent-color)' }}>
          <Sparkles size={18} />AI調整候補生成
        </button>
      </div>
      <div className="card overflow-hidden">
        {isLoading ? (
          <div className="flex items-center justify-center h-64"><div className="w-8 h-8 border-2 border-blue-600/30 border-t-blue-600 rounded-full animate-spin" /></div>
        ) : data?.data.length === 0 ? (
          <div className="text-center py-12">
            <Calculator size={48} className="mx-auto mb-4" style={{ color: 'var(--text-muted)' }} />
            <p style={{ color: 'var(--text-secondary)' }}>調整項目がありません</p>
          </div>
        ) : (
          <table>
            <thead><tr>
              <th style={{ color: 'var(--text-primary)' }}>調整区分</th>
              <th style={{ color: 'var(--text-primary)' }}>科目</th>
              <th className="text-right" style={{ color: 'var(--text-primary)' }}>会計金額</th>
              <th className="text-right" style={{ color: 'var(--text-primary)' }}>税務金額</th>
              <th className="text-right" style={{ color: 'var(--text-primary)' }}>調整額</th>
              <th style={{ color: 'var(--text-primary)' }}>加減</th>
              <th style={{ color: 'var(--text-primary)' }}>承認</th>
            </tr></thead>
            <tbody>
              {data?.data.map((adj: any) => (
                <tr key={adj.id}>
                  <td style={{ color: 'var(--text-primary)' }}>{adj.adjustmentType}</td>
                  <td style={{ color: 'var(--text-secondary)' }}>{adj.accountCode} {adj.accountName}</td>
                  <td className="text-right font-mono" style={{ color: 'var(--text-primary)' }}>¥{parseFloat(adj.accountingAmount).toLocaleString()}</td>
                  <td className="text-right font-mono" style={{ color: 'var(--text-primary)' }}>¥{parseFloat(adj.taxAmount).toLocaleString()}</td>
                  <td className="text-right font-mono font-bold" style={{ color: adj.adjustmentDirection === '加算' ? 'var(--error)' : 'var(--success)' }}>
                    {adj.adjustmentDirection === '加算' ? '+' : '-'}¥{parseFloat(adj.adjustmentAmount).toLocaleString()}
                  </td>
                  <td><span className={`badge ${adj.adjustmentDirection === '加算' ? 'badge-error' : 'badge-success'}`}>{adj.adjustmentDirection}</span></td>
                  <td>{adj.isApproved ? <Check className="text-green-600" size={18} /> : <input type="checkbox" />}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

